import MultipleSwitchBox from 'lib/MultipleSwitchBox';
import { FilterMarketStatus as FilterMarketStatusType, FilterMarketStatusProps } from './FilterMarketStatus.types';

const marketStatuses = [
  { label: 'All', value: '' },
  { label: 'Missing market', value: 'false' },
  { label: 'Market assigned', value: 'true' },
];

const FilterMarketStatus = ({ changeFilters, value }: FilterMarketStatusProps): React.ReactElement => {
  return (
    <div className="flex whitespace-nowrap">
      <MultipleSwitchBox
        source={marketStatuses}
        selectedValue={value || ''}
        textKey="label"
        valueKey="value"
        onChange={(marketStatus: FilterMarketStatusType['marketStatus']) => changeFilters({ marketStatus })}
      />
    </div>
  );
};

export default FilterMarketStatus;
